import { render } from "./KitchenCompletedTickets.vue?vue&type=template&id=006f7eff"
import script from "./KitchenCompletedTickets.vue?vue&type=script&lang=js"
export * from "./KitchenCompletedTickets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__